/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Card } from '@brokerbay/design-components';
import { BillingInvoicesPageContext } from '../../BillingInvoicesPageContext';
import { FormStatus } from '../FormStatus';
import BillingEmailCard from './BillingEmailCard';
import BillingAddressCard from './BillingAddressCard';
import {
  StyledBillingDetailsContainer,
  StyledContainer,
  StyledNoContent,
} from './styledComponents';
import { CanManageBillingProfileType } from '../../../SubscriptionsPaymentsPage/SubscriptionsPageContext';

export type ContentProps = {
  canManageBilling: CanManageBillingProfileType;
};

const BillingDetailsCard: React.FC<ContentProps> = ({ canManageBilling }) => {
  const { billingProfile, hasSavedCard } = useContext(
    BillingInvoicesPageContext,
  );

  return (
    <Card title="Contact Details">
      {billingProfile ? (
        <StyledBillingDetailsContainer>
          {canManageBilling.response === false && (
            <StyledFormStatus status="info" text={canManageBilling.message} />
          )}
          {!hasSavedCard && (
            <StyledFormStatus
              status="info"
              text="Credit card must be updated before you can update your email and address."
            />
          )}
          <StyledContainer>
            <BillingEmailCard canManageBilling={canManageBilling} />
          </StyledContainer>

          <StyledContainer>
            <BillingAddressCard canManageBilling={canManageBilling} />
          </StyledContainer>
        </StyledBillingDetailsContainer>
      ) : (
        <StyledNoContent>No contact details found</StyledNoContent>
      )}
    </Card>
  );
};

const StyledFormStatus = styled(FormStatus)`
  margin-bottom: 16px;
`;

export default BillingDetailsCard;
